const ip_address = {
	nav: {
		manage: "Uw IP-adressen",
		title: "IP-adressen",
	},
	title: "Uw IP-adressen",
};

export default ip_address;
